import { render, staticRenderFns } from "./RuleConfiguration.vue?vue&type=template&id=b54817f6&scoped=true"
import script from "./RuleConfiguration.vue?vue&type=script&lang=js"
export * from "./RuleConfiguration.vue?vue&type=script&lang=js"
import style0 from "./RuleConfiguration.vue?vue&type=style&index=0&id=b54817f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54817f6",
  null
  
)

export default component.exports